/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import { changeLanguageFromCurrentUrl, getLocalizedByName, getLocalizedByParams, getLocalizedByUrl, urlResolve, isLookCategory, isProductUrl, pathTranslate } from './routeHelpers'
import { slugify, isOnline, getThumbnailPath, mapAddress, mapCheckoutAddress, getSuffixGuest, graphqlManageError, findActiveCountry, giftCardFormDecorator, toCapitalize, scrollTo, randomInRange, getVariantByFilter, isMobile } from './utils'

export {
  changeLanguageFromCurrentUrl,
  getLocalizedByName,
  getLocalizedByParams,
  getLocalizedByUrl,
  slugify,
  isOnline,
  getThumbnailPath,
  pathTranslate,
  mapAddress,
  mapCheckoutAddress,
  getSuffixGuest,
  graphqlManageError,
  findActiveCountry,
  urlResolve,
  isLookCategory,
  isProductUrl,
  giftCardFormDecorator,
  toCapitalize,
  scrollTo,
  randomInRange,
  isMobile,
  getVariantByFilter
}

export const EventBus = new Vue()
